import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BsChevronLeft } from "react-icons/bs";
import Loading from "../../Loading";
import { prices } from "../../../Utils/contstant";
import { useMainContext } from "../../../Context";
import { nesdata } from "../../../Utils/Apis";
import { useQuery } from "../../../Hooks";
import AdSlider from "../../../Pages/Home/components/AdSliders";
import sliderImg1 from "../../../Assets/images/Ad/AdBaner (1)-min.jpg";
import sliderImg2 from "../../../Assets/images/Ad/AdBaner (2)-min.jpg";

const CategoryList = ({ changeObj, getValue, clear }) => {
  const [selected, setSelected] = useState({});
  const [adSrc, setAdSrc] = useState([sliderImg1, sliderImg2]);

  const {
    state: { mainData },
    post,
    handler,
  } = useMainContext();

  if (!mainData) {
    return (
      <div className="category-list-card">
        <Loading height={"500px"} />
      </div>
    );
  }


  return (
    <div className="sticky-top">
      <div className="category-list-card border">
        <h5 className="mb-4">دسته بندی :‌</h5>
        <a className="pointer" to={"/"} onClick={clear}>
          <span className="fs-15">همه آگهی ها</span>
        </a>

        <ul className="first-layer ps-0">
          {mainData?.categories.map(cat => {
            return (
              <li
                data-active={cat.id == getValue("category_parent_id")}
                className={`catItem`}
              >
                <a
                  onClick={() => {
                    changeObj(
                      "category_parent_id",
                      getValue("category_parent_id") ? "" : cat.id
                    );
                  }}
                >
                  {cat.title}
                  <BsChevronLeft className="mt-1" />
                </a>
                {cat.childs && (
                  <ul
                    className={`px-3 mt-2 second-layer ${getValue("category_parent_id") == cat.id ? "active" : " "
                      }`}
                  >
                    {cat.childs.map(nes => {
                      return (
                        <li
                          data-active={nes.id == getValue("category_id")}
                          className="childCat"
                          onClick={() => {
                            changeObj("category_id", nes.id);
                          }}
                        >
                          <a to={"/"}>{nes.title}</a>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="category-list-card border">
        <h5 className="mb-3">بازه قیمتی:</h5>
        <div className="price-filters">
          {prices.map((item, key) => {
            return (
              <div
                className="price-filter pointer mb-2"
                onClick={() => {
                  changeObj("price", item.key);
                }}
                key={key}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id={"exampleRadios2" + "-" + key}
                  checked={getValue("price") == item.key}
                />
                <label
                  className="form-check-label fs-14 pointer"
                  htmlFor={"exampleRadios2" + "-" + key}
                >
                  {item.label}
                </label>
              </div>
            );
          })}
        </div>
      </div>

      {/* Ad Slider */}
      <div className="row">
        <div className="col-12">
          <AdSlider srcData={adSrc} classImg={"doubleSliderbox"} />
        </div>
        <div className="col-12">
          <AdSlider srcData={adSrc} classImg={"doubleSliderbox"} />
        </div>
      </div>
    </div>
  );
};

export default CategoryList;
